import React from "react";
import { Check } from "lucide-react";
import styles from "./MemberStepper.module.css";

const STEPS = [
  { id: "01", label: "Basic\nInformation" },
  { id: "02", label: "Email\nVerification" },
  { id: "03", label: "Phone\nVerification" },
  { id: "04", label: "Member\nProfile Details" },
  { id: "05", label: "Set\nPreferences" },
  { id: "06", label: "Choose\nMembership" },
];

const MOBILE_STEPS_INFO = [
  { title: "Basic Information", next: "Email Verification", progress: "1/6" },
  { title: "Email verification", next: "Phone Verification", progress: "2/6" },
  { title: "Phone verification", next: "Member Profile Detail", progress: "3/6" },
  { title: "Member Profile Details", next: "Set Preferences", progress: "4/6" },
  { title: "Set Preferences", next: "Almost Done", progress: "5/6" },
  { title: "Choose Membership", next: "Pricing", progress: "6/6" },
];

interface MemberStepperProps {
  activeStep: number;
}

const getVisualStep = (appStep: number) => {
  if (appStep <= 3) return appStep; // 0 (Basic Info), 1 (Email), 2 (Phone), 3 (Profile Details)
  if (appStep === 4 || appStep === 5) return 4; // 4 (More About You) and 5 (Lifestyle Profile) map to visual step 4 (Set Preferences)
  if (appStep === 6) return 5; // 6 (Choose Membership) maps to visual step 5 (Choose Membership)
  return appStep;
};

export default function MemberStepper({ activeStep }: MemberStepperProps) {
  const visualStep = getVisualStep(activeStep);
  const mobileInfo = MOBILE_STEPS_INFO[visualStep] || MOBILE_STEPS_INFO[0];

  return (
    <>
      {/* Desktop Stepper */}
      <div className={styles.stepperContainer}>
        {STEPS.map((step, index) => {
          const isCompleted = index < visualStep;
          const isActive = index === visualStep;

          let circleClass = styles.stepCircle;
          let labelClass = styles.stepLabel;

          if (isCompleted) {
            circleClass = `${styles.stepCircle} ${styles.completedStepCircle}`;
            labelClass = `${styles.stepLabel} ${styles.completedStepLabel}`;
          } else if (isActive) {
            circleClass = `${styles.stepCircle} ${styles.activeStepCircle}`;
            labelClass = `${styles.stepLabel} ${styles.activeStepLabel}`;
          }

          return (
            <div key={step.id} className={styles.step}>
              <div className={circleClass}>
                {isCompleted ? <Check size={16} strokeWidth={3} /> : step.id}
              </div>
              <div className={labelClass} style={{ whiteSpace: "pre-line" }}>
                {step.label}
              </div>
            </div>
          );
        })}
      </div>

      {/* Mobile Stepper */}
      <div className={styles.mobileStepperContainer}>
        <div className={styles.mobileTextSection}>
          <h2 className={styles.mobileTitle}>{mobileInfo.title}</h2>
          <p className={styles.mobileNext}>Next : {mobileInfo.next}</p>
        </div>
        <div className={styles.mobileProgressCircle}>
          <span className={styles.mobileProgressText}>{mobileInfo.progress}</span>
        </div>
      </div>
    </>
  );
}
